import React from 'react';
import { Modal } from '@mantine/core';
import { useNavigate, useParams, useLocation } from 'react-router';
import { useMobile } from '@/hooks';
import { PopupUpcoming } from './PopupUpcoming';
import { PopupCompleted } from './PopupCompleted';
import { CateringUpcoming } from './CateringUpcoming';
import { CateringCompleted } from './CateringCompleted';
import { DeliveryUpcoming } from './DeliveryUpcoming';
import { DeliveryCompleted } from './DeliveryCompleted';
import { wentWrong } from '@/helpers';
import { Page, ROUTES } from '@/constants';

const EventView = {
  popup_upcoming: PopupUpcoming,
  popup_completed: PopupCompleted,
  catering_upcoming: CateringUpcoming,
  catering_completed: CateringCompleted,
  delivery_upcoming: DeliveryUpcoming,
  delivery_completed: DeliveryCompleted,
};

const EventPage: React.FC = () => {
  const { type, id } = useParams<{ type: string; id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMobile();

  if (!type || !id || !(type in EventView)) {
    return null;
  }

  const View = EventView[type as keyof typeof EventView];

  const handleClose = () => {
    const isDashboard = location.pathname.includes(ROUTES[Page.Dashboard]);
    const isCalendar = location.pathname.includes(ROUTES[Page.Calendar]);

    if (isDashboard) {
      navigate(ROUTES[Page.Dashboard]);
    } else if (isCalendar) {
      navigate(ROUTES[Page.Calendar]);
    } else {
      navigate(-1);
    }
  };

  return (
    <Modal.Root opened onClose={handleClose} fullScreen={isMobile} size={500}>
      <Modal.Overlay />
      <View
        id={id}
        onCloseWithoutEvent={() => {
          wentWrong('Event not found, please check the event parameters and try again');
          handleClose();
        }}
      />
    </Modal.Root>
  );
};

export default EventPage;
